import React, { Component } from 'react';
import {
	BrowserRouter as Router,
	HashRouter,
	Route,
	Link,
	Switch,
	Redirect
} from 'react-router-dom';
//import logo from './logo.svg';
import './App.css';
//import MenuAppBar from "./components/MenuAppBar";
import ClippedDrawer from "./components/ClippedDrawer";
import Login from "./components/Login/login";
import axios from 'axios';
import config from './config/config'
import {connect} from 'react-redux'
import {aAction_open_menu,
	aAction_add_menu,
	aLogin,
	aLogout
} from './redux/actions'


class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
        	username: "",
			token: "",
			routeData:[]
		};
	}

	componentWillMount() {
		const loginState = sessionStorage.getItem("loginState");
		const username = sessionStorage.getItem("username");
		const token = sessionStorage.getItem("token");
		if (loginState) {
			this.props.dLogin()
		}
		this.setState({ username: username, token: token });
	}

	login = (islogined, username, token) => {
		this.setState({ username: username, token: token.token })
		console.log("set log in")
		//this.props.dLogin()
		if (islogined) {
			this.props.dLogin()
		}
		sessionStorage.setItem("loginState", islogined)
		sessionStorage.setItem("username", username)
		sessionStorage.setItem("token", token.token)
	}

	createRoute(data) {
		return data.map(row=>{
			let route = row.route.toLowerCase();
			return route.substring(route.lastIndexOf('/'));
		})
	}

	componentDidMount() {
        axios.get(config.menu).then(res=>{
			// console.log("get menu")
			// console.log(res.data.results)
			// console.log(this.createRoute(res.data.results))
			this.setState({routeData:this.createRoute(res.data.results)})
		});
    }

	render() {
		//console.log(this.state.logined);
		const publicPath = '';
		// console.log(this.props.logined)
		// console.log(this.props)
		//console.log(publicPath + '/login')
		return (
			<Router>
			{/* <HashRouter> */}
				<div className='App'>
					<Switch>
					<Route exact path={[publicPath + '/login', publicPath + "/"]} render={(props)=><Login {...props} login={this.login}/>}/>
					{/* <Route
						exact path={[publicPath + '/dashboard', publicPath + '/invoice',publicPath + '/vendor',publicPath + '/transaction',publicPath + '/employee',
							publicPath + '/purchase order',publicPath + '/customer',publicPath + '/conflict of interest',publicPath + '/duplicate address',
							publicPath + '/duplicate po',publicPath + '/benford', publicPath + '/enterprise rm']} 		
						render={(props)=>this.state.logined ? 
							<ClippedDrawer {...props} username={this.state.username} token = {this.state.token}/> : 
							<Login {...props} login={this.login}/>}/> */}
					<Route
						exact path={this.state.routeData}
						render={(props)=>this.props.logined ?
							<ClippedDrawer {...props} username={this.state.username} token = {this.state.token}/> :
							<Login {...props} login={this.login}/>}/>
					<Route
						render={(props)=>this.props.logined ?
							<ClippedDrawer {...props} username={this.state.username} token = {this.state.token}/> :
							<Login {...props} login={this.login}/>}/>
					</Switch>
     		   </div>
     		   {/* </HashRouter> */}
			</Router>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
  // ... computed data from state and optionally ownProps
  	// console.log(state)
  	// console.log(ownProps)
    return {
  		logined: state.logined
  	}
}

const mapDispatchToProps = dispatch => {
  // ... normally is an object full of action creators
  	return {
  		aAction_open_menu,
		aAction_add_menu,
		dLogin: () => { dispatch(aLogin) },
		dLogout: () => { dispatch(aLogout) }
	}
}

// `connect` returns a new function that accepts the component to wrap:
const connectToStore = connect(
  mapStateToProps,
  mapDispatchToProps
)

// and that function returns the connected, wrapper component:
const ConnectedComponent = connectToStore(App)
export default ConnectedComponent



// WEBPACK FOOTER //
// ./src/App.js